import styled from 'styled-components';

export const StepContainer = styled.div`
    height: 40px
    width: 50%;
`;
